import $ from 'jquery';

$(function () {
  var radioName = 'input[name="company[profile_image_setting]"]';
  var checked = $(radioName + ':checked').data('setting');
  var uploadImage = $('.js-default-profile-picture');
  $(radioName + ':radio').change(function () {
    checked = $(radioName + ':checked').data('setting');
    if (checked == 'users_choice') {
      uploadImage.addClass('hidden');
    } else {
      uploadImage.removeClass('hidden');
    }
  });
});
